








import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { Link, useNavigate } from "react-router-dom";

import { FaEdit, FaEnvelope, FaPhone } from "react-icons/fa";

import NoResultFoundModel from "../NoDataFound";

import { AuthContext, LoaderContext } from "../../../Context/ContextFunctions";



import { ChangeClientStatus, GetClientList, DeleteClient } from "../../../services/Client/ClientApi";
import Android12Switch from "../AndroidSwitch";

const CompletedTasks = () => {
      const navigate = useNavigate();
      const [fromDate, setFromDate] = useState(null);
      const [toDate, setToDate] = useState(null);

      const [errorMessage, setErrorMessage] = useState(false);
      const [isErrorOpen, setIsErrorOpen] = useState(false);
      const [isAddUpdateDone, setIsAddUpdateDone] = useState(false);
      const [confirmationModal, setConfirmationModal] = useState(false);
      const [modelAction, setModelAction] = useState("");
      const [showSuccessPopupModal, setShowSuccessPopupModal] = useState(false);
      const [modelRequestData, setModelRequestData] = useState({
            KeyID: null,
            Action: null,
            status: null,
            Name: null,
            remark: null,
      });
      //List Params
      const [ClientSearch, setClientSearch] = useState("");
      const [ClientList, setClientList] = useState([]);
      const [ClientListCount, setClientListCount] = useState(-1);
      const [ClientCurrentPage, setClientCurrentPage] = useState(1);
      //Context
      const { setLoader } = useContext(LoaderContext);
      const { authDetails, pageSize, PanalModuleName, defaultAccess } =
            useContext(AuthContext);
      //initial UseEffect
      useEffect(() => {
            GetClientListData(1, "Active");
      }, []);

      useEffect(() => {
            if (isAddUpdateDone) {
                  setClientSearch("");
                  GetClientListData(1, "Active", null);
                  setIsAddUpdateDone(false);
            }
      }, [isAddUpdateDone]);
      //Client Role List Api
      const GetClientListData = async (i, tab, searchKeyword) => {
            const pageNoList = i - 1;
            try {
                  setLoader(true);
                  let response = await GetClientList({
                        moduleName: PanalModuleName,
                        pageSize: pageSize,
                        pageNo: pageNoList,
                        searchKeyword:
                              searchKeyword === undefined ? ClientSearch : searchKeyword,
                        userKeyID: authDetails.userKeyID,
                        moduleName: tab,
                  });
                  if (response.statusCode === 200) {
                        setLoader(false);
                        const list = response.responseData?.data;
                        setClientListCount(response.totalCount);
                        setClientList(list);
                  } else {
                        setLoader(false);
                  }
            } catch (error) {
                  setLoader(false);
                  console.log(error);
            }
      };

      //Confirmation Button Click
      const handleConfirmBtn = async () => {
            setLoader(true);
            if (modelAction === "Delete") {
                  let data = await DeleteClient(
                        PanalModuleName,
                        modelRequestData.KeyID,
                        authDetails.userKeyID
                  );
                  try {
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setConfirmationModal(false);
                              setIsErrorOpen(true);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            } else if (modelAction === "Status") {
                  try {
                        let data = await ChangeClientStatus(
                              PanalModuleName,
                              modelRequestData.KeyID,
                              authDetails.userKeyID
                        );
                        if (data?.statusCode === 200) {
                              setLoader(false);
                              setIsAddUpdateDone(true);
                              setConfirmationModal(false);
                              setShowSuccessPopupModal(true);
                        } else {
                              setLoader(false);
                              setIsErrorOpen(true);
                              setConfirmationModal(false);
                              const errorMessage = data?.response?.data?.errorMessage;
                              setErrorMessage(errorMessage);
                        }
                  } catch (error) {
                        setLoader(false);
                  }
            }
      };
      //Change Page Button
      const HandlePageChange = async (pageNumber) => {
            setClientCurrentPage(pageNumber);
            await GetClientListData(pageNumber, "Active"); // Call your function with the selected page number
      };

      const handleSearchFunction = (searchValue) => {
            setClientSearch(searchValue);
            GetClientListData(1, "Active", searchValue);
      };

      const handleViewClient = (client) => {
            navigate("/viewClient", {
                  state: {
                        clientKeyID: client.clientKeyID,
                        clientName: client.clientName,
                        Action: "View",
                  },
            });
      };

      return (
            <>
                  <div className="z-10 space-y-6 mx-auto rep-width mx-auto px-4">
                        <div className="h-full bg-white shadow rounded-lg flex flex-col">
                              {/* Header Section */}
                              <div
                                    style={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          padding: "4px 15px",
                                    }}
                                    className="border-b p-4 overflow-x-auto"
                              >
                                    <div className="flex space-x-4">
                                          <button
                                                className={`px-4 py-2 whitespace-nowrap border-b-2 border-blue-500 text-[#135EA0] text-12`}
                                          >
                                                Completed Tasks
                                          </button>
                                    </div>
                              </div>
                              <div className="p-2 border-b flex flex-wrap sm:flex-nowrap items-center justify-between gap-3">
                                    {/* Left Side: Select Dropdown */}
                                    <div></div>

                                    {/* Right Side: Search Bar & Add Button */}
                                    <div className="flex flex-wrap sm:flex-nowrap items-center w-full sm:w-auto gap-3">
                                          {/* Search Bar */}
                                          <div className="relative flex items-center w-full sm:w-64">
                                                <span className="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-700"></span>
                                                <input
                                                      type="text"
                                                      className="border text-12 border-gray-200 shadow appearance-none rounded py-2 p-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline focus:ring-2 focus:ring-sky-600 w-full"
                                                      placeholder="Search Task "
                                                      value={ClientSearch}
                                                      onChange={(e) => {
                                                            handleSearchFunction(e.target.value, PanalModuleName);
                                                      }}
                                                />
                                          </div>


                                    </div>
                              </div>
                              {/* Tab Content */}
                              {/* <div className="p-4"> */}
                              <div className="flex flex-col table_wrapper border border-gray-200">
                                    <div className="flex-1 overflow-y-auto">
                                          <table className="w-full border-collapse border border-gray-200 text-12 table-auto">
                                                <thead>
                                                      <tr className="z-1 sticky top-0 bg-white">
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Project
                                                            </th>

                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Task Name                                                            </th>
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Assigned To
                                                            </th>
                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Priority
                                                            </th>

                                                            <th className="text-12 border-b border-slate-200 bg-slate-50  whitespace-nowrap p-1">
                                                                  Completed On
                                                            </th>
                                                      </tr>
                                                </thead>
                                                <tbody>
                                                      {ClientList.map((client, index) => (
                                                            <>
                                                                  <tr
                                                                        key={index}
                                                                        className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                                                  >
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              CRM Revamp
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              API Documentation Update
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              Sandeep Maurya
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              Low
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              15 Oct 2025
                                                                        </td>
                                                                  </tr>
                                                                  <tr
                                                                        key={index}
                                                                        className="hover:bg-slate-50 border-b border-slate-200 text-center"
                                                                  >
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              Payment Gateway Integration
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              Sujit Prajapati
                                                                        </td>


                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              High
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              14 Oct 2025
                                                                        </td>
                                                                        <td className="whitespace-nowrap  px-2 py-2">
                                                                              Order Management

                                                                        </td>




                                                                  </tr>

                                                            </>
                                                      ))}
                                                </tbody>
                                          </table>
                                          {ClientListCount <= 0 && (
                                                <NoResultFoundModel totalRecords={ClientListCount} />
                                          )}
                                    </div>


                              </div>

                              {/* </div> */}
                        </div>
                  </div>
            </>
      );
};

export default CompletedTasks;
